import React from 'react';
import { EventRowNFL } from './eventRowNFL/EventRowNFL';
import { EventRowNBA } from './eventRowNBA/EventRowNBA';
import { EventRowMLB } from './eventRowMLB/EventRowMLB';
import { EventRowNHL } from './eventRowNHL/EventRowNHL';
import { EventsGroupViewCompetition } from 'src/domains/sportsbook/state/eventsListState/eventsGroup/EventsGroupView';
import { checkCompetition } from 'src/domains/sportsbook/utils/checkCompetition';
import { observer } from 'src/utils/mobx-react';
import { EventRow } from 'src/domains/sportsbook/webview/components/eventRow/EventRow';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import { EventsListGroupWrapper } from './EventList.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface EventsListGroupEventsPropsType {
    competitionGroup: EventsGroupViewCompetition;
    filterMarketsByPopularTag: boolean;
}

export const EventsListGroupEvents = observer('EventsListGroupEvents', (props: EventsListGroupEventsPropsType) => {
    const { competitionGroup, filterMarketsByPopularTag } = props;

    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const sport = competitionGroup.sport;
    const competitionName = competitionGroup.name;

    const isMLBorMajorCompetition = checkCompetition(competitionName, ['MLB', 'Major']) && sport === 'baseball';
    const isNHL = checkCompetition(competitionName, ['NHL']);
    const isNBA = checkCompetition(competitionName, ['NBA']);
    const isNFL = competitionName === 'US NFL' || competitionName === 'NFL Matches';

    const renderEvent = (event: EventListGroupEventItemType): JSX.Element => {
        const isTwoParticipant = event.template.startsWith('two-participant');

        if (isMLBorMajorCompetition && isTwoParticipant) {
            return (
                <EventRowMLB
                    key={`event_${event.id}`}
                    eventId={event.id2}
                    smallEvent={event}
                    showParticipantLogos={true}
                />
            );
        }
        if (isNHL && isTwoParticipant) {
            return (
                <EventRowNHL
                    key={`event_${event.id}`}
                    eventId={event.id2}
                    smallEvent={event}
                />
            );
        }
        if (isNBA && isTwoParticipant) {
            return (
                <EventRowNBA
                    key={`event_${event.id}`}
                    eventId={event.id2}
                    smallEvent={event}
                />
            );
        }
        if (isNFL) {
            return (
                <EventRowNFL
                    key={`event_${event.id}`}
                    eventId={event.id2}
                    smallEvent={event}
                />
            );
        }
        return (
            <EventRow
                key={`event_${event.id}`}
                smallEvent={event}
                possibleMarketAndSelectionInList={competitionGroup.possibleMarketAndSelectionInList}
                filterMarketsByPopularTag={filterMarketsByPopularTag}
            />
        );
    };

    return (
        <EventsListGroupWrapper variant={configState.componentVariants.sportsbookVariant}>
            {competitionGroup.events.map(renderEvent)}
        </EventsListGroupWrapper>
    );
});
